import { FONT_COLOURS } from '@belong/themes';
import { ICON_NAMES } from '@belong/types';
import { IHeaderBarLink } from '../GlobalHeaderDesktop/HeaderBarButton';
import { LinkText, WrapperWithLink } from '../GlobalHeaderDesktop/HeaderBarButton/styles';
import { StyledIconWithDot } from './styles';

interface IDesktopNbnCartButton extends IHeaderBarLink {
  href: string;
  iconName: ICON_NAMES;
  menuLabel: string;
}

export const DesktopNbnCartButton = ({ href, iconName, menuLabel, ...otherProps }: IDesktopNbnCartButton) => {
  return (
    <WrapperWithLink href={href} {...otherProps}>
      <LinkText hasColor={FONT_COLOURS.LIGHT}>
        <StyledIconWithDot name={iconName} isDesktop />
        {menuLabel}
      </LinkText>
    </WrapperWithLink>
  );
};

DesktopNbnCartButton.displayName = 'DesktopNbnCartButton';
